import { render, staticRenderFns } from "./LatestFiles.vue?vue&type=template&id=4dfa042c&scoped=true&lang=pug"
import script from "./LatestFiles.vue?vue&type=script&lang=js"
export * from "./LatestFiles.vue?vue&type=script&lang=js"
import style0 from "./LatestFiles.vue?vue&type=style&index=0&id=4dfa042c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa042c",
  null
  
)

export default component.exports